import React from 'react'
import {
  CFSelect,
  CFView,
  CFImage,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { orderDeliveryButton } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView>
          <MobileScreen>
            <a
              href={`https://www.order.store/store/sushi-karis/6YId4VZiRXiiDJg-0EjwMQ`}
            >
              <CFView hover>
                <CFImage
                  src={orderDeliveryButton}
                  w="67%"
                  maxWidth="=300px"
                  alt="About"
                />
              </CFView>
            </a>
          </MobileScreen>
          <DefaultScreen>
            <a
              href={`https://www.order.store/store/sushi-karis/6YId4VZiRXiiDJg-0EjwMQ`}
            >
              <CFView hover>
                <CFImage
                  src={orderDeliveryButton}
                  w="100%"
                  maxWidth="300px"
                  alt="About"
                />
              </CFView>
            </a>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
